<template>
  <section class="pt-5 pb-5">
    <div class="posts">
            <h1>Posts</h1>
            <ul>
                <li v-for="post in posts" :key="post.id">
                     {{ post.title.rendered  }}
                </li>
            </ul>
        </div>
  </section>
</template>

<script>


export default {
        mounted() {
            this.getPosts();
        },

        data() {
            return {
                postsUrl: 'http://dev.58studio.de/wordpress/wp-json/testimonials/v1/post',
                posts: [],
                postsData: {
                    per_page: 10,
                    page: 1
                },

            }
        },
        methods: {

            getPosts() {
              axios.get(this.postsUrl, {params: this.postsData})
                    .then((response) => {
                        this.posts = response;
                          this.configPagination(response.headers);
                    })
                    .catch( (error) => {
                        console.log(error);
                    });
            },

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
</style>
